import { configureStore, createSlice } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './slices/authSlice';

// Create a basic app reducer slice
const appSlice = createSlice({
    name: 'app',
    initialState: {
        isLoading: false,
        error: null,
        user: null
    },
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        }
    }
});

// Export actions
export const { setLoading, setError, setUser } = appSlice.actions;

export const store = configureStore({
    reducer: {
        app: appSlice.reducer,
        auth: authReducer,
        // Add other reducers here as needed
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
